"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchInstalledEcommerceAppIds = exports.FetchInstalledEcommerceAppIdsActions = exports.FetchInstalledEcommerceAppIdsActionTypes = exports.disconnectShopify = exports.DisconnectShopify = exports.DisconnectShopifyActionTypes = exports.FetchShopifyShop = exports.FetchShopifyShopActionTypes = exports.loadShopifyStatus = exports.FetchShopifyStatus = exports.FetchShopifyStatusActionTypes = exports.EcommerceActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _actions = require("settings-ui-lib/utils/actions");

var _createAction = _interopRequireDefault(require("flux-actions/createAction"));

var EcommerceActionTypes = (0, _namespacedKeyMirror.default)({
  FETCH_SHOPIFY_STATUS: null,
  FETCH_SHOPIFY_SHOP: null,
  DISCONNECT_SHOPIFY: null,
  SHOW_DISCONNECT_SHOPIFY_SUCCESS_ALERT: null,
  SHOW_DISCONNECT_SHOPIFY_FAILURE_ALERT: null,
  FETCH_INSTALLED_ECOMMERCE_APP_IDS: null
}, 'ecommerce');
exports.EcommerceActionTypes = EcommerceActionTypes;
var FetchShopifyStatusActionTypes = (0, _actions.createRequestTypes)(EcommerceActionTypes.FETCH_SHOPIFY_STATUS);
exports.FetchShopifyStatusActionTypes = FetchShopifyStatusActionTypes;
var FetchShopifyStatus = (0, _actions.createRequestActions)(FetchShopifyStatusActionTypes);
exports.FetchShopifyStatus = FetchShopifyStatus;
var loadShopifyStatus = (0, _createAction.default)(EcommerceActionTypes.FETCH_SHOPIFY_STATUS);
exports.loadShopifyStatus = loadShopifyStatus;
var FetchShopifyShopActionTypes = (0, _actions.createRequestTypes)(EcommerceActionTypes.FETCH_SHOPIFY_SHOP);
exports.FetchShopifyShopActionTypes = FetchShopifyShopActionTypes;
var FetchShopifyShop = (0, _actions.createRequestActions)(FetchShopifyShopActionTypes);
exports.FetchShopifyShop = FetchShopifyShop;
var DisconnectShopifyActionTypes = (0, _actions.createRequestTypes)(EcommerceActionTypes.DISCONNECT_SHOPIFY);
exports.DisconnectShopifyActionTypes = DisconnectShopifyActionTypes;
var DisconnectShopify = (0, _actions.createRequestActions)(DisconnectShopifyActionTypes);
exports.DisconnectShopify = DisconnectShopify;
var disconnectShopify = (0, _createAction.default)(EcommerceActionTypes.DISCONNECT_SHOPIFY, function (shop) {
  return shop;
});
exports.disconnectShopify = disconnectShopify;
var FetchInstalledEcommerceAppIdsActionTypes = (0, _actions.createRequestTypes)(EcommerceActionTypes.FETCH_INSTALLED_ECOMMERCE_APP_IDS);
exports.FetchInstalledEcommerceAppIdsActionTypes = FetchInstalledEcommerceAppIdsActionTypes;
var FetchInstalledEcommerceAppIdsActions = (0, _actions.createRequestActions)(FetchInstalledEcommerceAppIdsActionTypes);
exports.FetchInstalledEcommerceAppIdsActions = FetchInstalledEcommerceAppIdsActions;
var fetchInstalledEcommerceAppIds = (0, _createAction.default)(EcommerceActionTypes.FETCH_INSTALLED_ECOMMERCE_APP_IDS);
exports.fetchInstalledEcommerceAppIds = fetchInstalledEcommerceAppIds;